module.exports = __webpack_public_path__ + "img/2100_YR_2022_Logo.43965297.png";